import moment from 'moment/moment';
import React from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import List from '#app/View/Accounting/components/List';
import Search from '#app/View/Accounting/components/Search';
import OrderClientEntryPoints from '#app/entrypoints/orderClient';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { ShopPayment } from '#app/typings/orderClient';

export type Filters = {
  startDate?: string;
  endDate?: string;
  shops?: number[];
};

const ShopPaymentList: React.FC = () => {
  const { setFilters, filters, ...props } = useCollectionPaginated<ShopPayment, Filters>(
    OrderClientEntryPoints.getCollectionShopPayment,
    {
      filters: {
        startDate: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endDate: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
      },
    },
  );

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Encaissements boutique', context: 'Comptabilité"' }}>
      <Search filters={filters} handleSearch={(data) => setFilters(data)} />
      <List {...props} />
    </ContentViewComponent>
  );
};

export default ShopPaymentList;
